export default __webpack_public_path__ + "img/dXGNQXFI.9f7a5b17.svg";